var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pr-4 py-4",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_c('v-progress-linear',{attrs:{"background-opacity":"0.3","height":_vm.height,"value":_vm.value,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }